module.exports = function getResource(label, vars = []) {
    let resources = {
        recommended: 'Recommandé',
        reviews: 'Commentaires',
        summary: 'Résumé'
    };
    return resources[label];
};
